// export const integrationsRoute = (slug = ':slug') => `/proyectos/${slug}/integraciones`;
export const homeRoute = '/';
export const dashboardRoute = '/dashboard';
export const loginRoute = '/ingresar';
export const headquartersRoute = '/sedes';
export const createHeadquartersRoute = '/nueva-sede';
export const editHeadquartersRoute = '/editar-sede';
export const teamRoute = '/equipo';
export const createTeamRoute = '/nuevo-colaborador';
export const inventoryRoute = '/inventario';
export const createInventoryRoute = '/nuevo-item';
export const editInventoryRoute = '/editar-item';
export const thirdsRoute = '/terceros';
export const createThirdsRoute = '/nueva-entidad';
export const cashRegisterRoute = '/ventas';
export const createCashRegisterRoute = '/nueva-venta';
export const cashRegisterDetailRoute = '/detalle-venta';
export const dashCashRegisterDetailRoute = '/dashboard/detalle';